<template>
    <v-container grid-list-xs fluid>
        <v-card>
            <v-toolbar color="primary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">
                    Missing PaperWork Email
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-form ref="form" v-model="valid" lazy-validation>
                    <v-row justify="center" class="mb-2">
                        <v-col cols="2">
                            <v-text-field name="Start Date" label="Start Date" v-mask="'####-##-##'" v-model="DateStart"
                                dense hide-details :rules="dateRules" required placeholder="yyyy-mm-dd"></v-text-field>
                        </v-col>

                        <v-col cols="2">
                            <v-text-field name="End Date" label="End Date" v-mask="'####-##-##'" v-model="DateEnd" dense
                                hide-details :rules="dateRules" required placeholder="yyyy-mm-dd"></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-combobox v-model="region" :items="regions" :item-text="'PrincipalRegion'"
                                :item-value="'PrincipalRegionID'" label="Select Region"
                                :rules="[v => !!v || 'Region is Required']" auto-select-first dense hide-details
                                required></v-combobox>
                        </v-col>
                        
                        <v-btn color="secondary" class="my-auto" icon elevation="3"
                            @click="validate"><v-icon>mdi-magnify</v-icon></v-btn>
                    </v-row>
                </v-form>
                <v-row>
                    <v-container grid-list-xs fluid>
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th colspan="2" width="1%">Shift</th>
                                    <th>ShiftDetail</th>
                                    <th>Region</th>
                                    <th width="8%">DriverName</th>
                                    <th colspan="3">Truck</th>
                                    <th colspan="3">Trailer</th>
                                    <th colspan="2">Yard</th>
                                    <th>Origin</th>
                                    <th colspan="3">DailySummary</th>
                                </tr>
                            </thead>
                            <tbody v-for="(miss) in missing" v-bind:key="miss.ShiftDetail">
                                <tr>
                                    <td style="background: #dceafc;text-align: center;">{{ miss.Date }}</td>
                                    <td style="background: #dceafc;text-align: center;" colspan="2" width="1%">{{ miss.Shift
                                    }}</td>
                                    <td style="background: #dceafc;text-align: center;" width="3%">{{ miss.ShiftDetail }}
                                    </td>
                                    <td style="background: #dceafc;text-align: center;" width="3%">{{ miss.PrincipalRegion
                                    }}</td>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">

                                            <td v-bind="attrs" v-on="on" style="background: #dceafc;text-align: center;"
                                                width="8%">{{ miss.DriverName }}</td>
                                        </template>
                                        <span>
                                            {{ miss.Email }}
                                        </span>
                                    </v-tooltip>
                                    <td style="background: #dceafc;text-align: center;" colspan="3">{{ miss.Truck }}</td>
                                    <td style="background: #dceafc;text-align: center;" colspan="3">{{ miss.Trailer }}</td>
                                    <td style="background: #dceafc;text-align: center;" colspan="2">{{ miss.Yard }}</td>
                                    <td style="background: #dceafc;text-align: center;">{{ miss.Origin === null ? 'Null' :
                                        miss.Origin }}</td>
                                    <td style="background: #dceafc;text-align: center;" colspan="3">
                                        <v-checkbox :disabled="true" v-model="miss.DailySummaryCheck" hide-details dense
                                            class="my-auto" style="float: left;"></v-checkbox>
                                            <v-badge
                                                            color="green"
                                                            overlap
                                                            :content="miss.mails"
                                                            :value="miss.mails != 0"
                                                            offset-x="16"
                                                            offset-y="12"
                                                        >
                                        <v-btn color="secondary" @click="sendMissingEmail(miss)" style="float: right;" small
                                            class="mr-2">Send <v-icon small class="my-auto ml-3">mdi-send</v-icon></v-btn>
                                                        </v-badge>
                                    </td>

                                </tr>
                                <tr>
                                    <th v-for="head in headerOrd" v-bind:key="head.value" :colspan="head.colspan"
                                        style="text-align: left;">
                                        {{ head.text }}
                                    </th>
                                </tr>
                                <tr v-for="ord in miss['orders']" v-bind:key="ord.OrderID">
                                    <td style="background: #fff;text-align: left;">{{ ord.OrderID }}</td>
                                    <td style="background: #fff;text-align: left;">{{ ord.LoadNum }}</td>
                                    <td style="background: #fff;text-align: left;">{{ ord.LoadNumOrd }}</td>
                                    <td style="background: #fff;text-align: left;">{{ ord.OrderStatus }}</td>
                                    <td style="background: #fff;text-align: left;" colspan="2">{{ ord.Customer }}</td>
                                    <td style="background: #fff;text-align: left;" colspan="2">{{ ord.TerminalName }}</td>
                                    <td style="background: #fff;text-align: left;" colspan="2">{{ ord.Station }}</td>
                                    <td style="background: #fff;text-align: left;">{{ ord.City }}</td>
                                    <td style="background: #fff;text-align: left;">{{ ord.BillOfLading }}</td>
                                    <td style="background: #fff;text-align: left;"><v-checkbox :disabled="true"
                                            v-model="ord.ppwCTI" hide-details dense class="my-auto"></v-checkbox></td>
                                    <td style="background: #fff;text-align: left;"><v-checkbox :disabled="true"
                                            v-model="ord.ppwBOL" hide-details dense class="my-auto"></v-checkbox></td>
                                    <td style="background: #fff;text-align: left;"><v-checkbox :disabled="true"
                                            v-model="ord.ppwSDC" hide-details dense class="my-auto"></v-checkbox></td>
                                    <td style="background: #fff;text-align: left;">{{ ord.SafeDischargeSheet }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </v-container>
                </v-row>
            </v-container>

        </v-card>
    </v-container>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mask } from 'vue-the-mask';
export default {

    directives: {
        mask
    },
    data: function () {
        return {
            header: [
                { text: 'Date', value: 'Date', width: '5%', colspan: '2' },
                { text: 'Shift', value: 'Shift', width: '2%', colspan: '2' },
                { text: 'Driver', value: 'DriverName', width: '10%', colspan: '2' },
                { text: 'Truck', value: 'Truck', width: '5%', colspan: '2' },
                { text: 'Trailer', value: 'Trailer', width: '5%', colspan: '2' },
                { text: 'Yard', value: 'Yard', width: '5%', colspan: '2' },
                { text: 'Origin', value: 'Origin', width: '5%', colspan: '1' },
                { text: 'DailySummaryCheck', value: 'DailySummaryCheck', width: '5%', colspan: '2' },
            ],
            headerOrd: [
                { text: 'OrderID', value: 'OrderID', width: '5%', colspan: '1' },
                { text: 'L1', value: 'LoadNum', width: '5%', colspan: '1' },
                { text: 'L2', value: 'LoadNumOrd', width: '5%', colspan: '1' },
                { text: 'OrderStatus', value: 'OrderStatus', width: '5%', colspan: '1' },
                { text: 'Customer', value: 'Customer', width: '5%', colspan: '2' },
                { text: 'Terminal', value: 'TerminalName', width: '5%', colspan: '2' },
                { text: 'Station', value: 'Station', width: '5%', colspan: '2' },
                { text: 'City', value: 'City', width: '5%', colspan: '1' },
                { text: 'BillOfLading', value: 'BillOfLading', width: '5%', colspan: '1' },
                { text: 'ppwCTI', value: 'ppwCTI', width: '5%', colspan: '1' },
                { text: 'ppwBOL', value: 'ppwBOL', width: '5%', colspan: '1' },
                { text: 'ppwSDC', value: 'ppwSDC', width: '5%', colspan: '1' },
                { text: 'SafeDischargeSheet', value: 'SafeDischargeSheet', width: '5%', colspan: '1' },
            ],
            missing: [],
            DateEnd: null,
            DateStart: null,
            regions: null,
            region: null,
            valid: true,
            dateRules: [
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect',

                v => !!v || 'Required'
            ],
        }
    },
    mounted() {
        this.loadRegions();
    },
    methods: {
        validate() {
            if (this.$refs.form.validate() == false) {
                this.$refs.form.validate();
            } else {
                this.loadMissingPapeWork();
                console.log('Validate')
            }
        },
        loadRegions: function () {
            this.$store.state.isLoading = true;
            axios
                .get('regions', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.regions = response.data;
                    this.regions.push({ PrincipalRegionID: 5, PrincipalRegion: "All" });
                    this.region = this.regions[3];
                })
                .catch(function (error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadMissingPapeWork: function () {
            var parms = {
                StartDate: this.DateStart,
                EndDate: this.DateEnd,
                Region: this.region.PrincipalRegionID
            }
            var str = this.$store;
            str.state.isLoading = true;

            axios
                .post('shift-detail/missing/ppw', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.missing = response.data;
                    str.state.isLoading = false;
                    console.log(this.missing);
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        sendMissingEmail: function (miss) {
            var parms = {
                missing: miss,
                SendDate: moment().format("YYYY-MM-DD HH:mm:ss"),
                
            }
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('shift-detail/send/missing/email', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    miss.mails++;
                    str.state.isLoading = false;
                    console.log(response.data);
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        }


    }
}


</script>